// Storage service for handling file uploads
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase/config';

// Upload celebration photo for a competition
export const uploadCelebrationPhoto = async (competitionId, file) => {
  // Validate file type
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload a JPG, PNG, or WebP image.');
  }

  // Validate file size (max 5MB)
  const maxSize = 5 * 1024 * 1024; // 5MB in bytes
  if (file.size > maxSize) {
    throw new Error('File size too large. Please upload an image smaller than 5MB.');
  }

  // Create a storage reference
  const timestamp = Date.now();
  const fileName = `celebration_${timestamp}.${file.name.split('.').pop()}`;
  const storageRef = ref(storage, `competitions/${competitionId}/celebration/${fileName}`);

  // Upload the file
  const snapshot = await uploadBytes(storageRef, file);

  // Get the download URL
  const downloadURL = await getDownloadURL(snapshot.ref);

  return downloadURL;
};

// Delete celebration photo
export const deleteCelebrationPhoto = async (photoUrl) => {
  try {
    // Extract the storage path from the URL
    const urlParts = photoUrl.split('/o/')[1].split('?')[0];
    const storagePath = decodeURIComponent(urlParts);

    const photoRef = ref(storage, storagePath);
    await deleteObject(photoRef);
  } catch (error) {
    console.error('Error deleting photo:', error);
    throw new Error('Failed to delete photo');
  }
};

// Upload winner photo for historical records
export const uploadWinnerPhoto = async (competitionId, file) => {
  // Validate file type
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload a JPG, PNG, or WebP image.');
  }

  // Validate file size (max 5MB)
  const maxSize = 5 * 1024 * 1024; // 5MB in bytes
  if (file.size > maxSize) {
    throw new Error('File size too large. Please upload an image smaller than 5MB.');
  }

  // Create a storage reference
  const timestamp = Date.now();
  const fileName = `winner_${timestamp}.${file.name.split('.').pop()}`;
  const storageRef = ref(storage, `competitions/${competitionId}/winners/${fileName}`);

  // Upload the file
  const snapshot = await uploadBytes(storageRef, file);

  // Get the download URL
  const downloadURL = await getDownloadURL(snapshot.ref);

  return downloadURL;
};

// Delete winner photo
export const deleteWinnerPhoto = async (photoUrl) => {
  try {
    // Extract the storage path from the URL
    const urlParts = photoUrl.split('/o/')[1].split('?')[0];
    const storagePath = decodeURIComponent(urlParts);

    const photoRef = ref(storage, storagePath);
    await deleteObject(photoRef);
  } catch (error) {
    console.error('Error deleting winner photo:', error);
    throw new Error('Failed to delete winner photo');
  }
};

// Upload winner photo for league hall of fame
export const uploadLeagueWinnerPhoto = async (leagueId, file) => {
  // Validate file type
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  if (!validTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload a JPG, PNG, or WebP image.');
  }

  // Validate file size (max 5MB)
  const maxSize = 5 * 1024 * 1024; // 5MB in bytes
  if (file.size > maxSize) {
    throw new Error('File size too large. Please upload an image smaller than 5MB.');
  }

  // Create a storage reference
  const timestamp = Date.now();
  const fileName = `winner_${timestamp}.${file.name.split('.').pop()}`;
  const storageRef = ref(storage, `leagues/${leagueId}/winners/${fileName}`);

  // Upload the file
  const snapshot = await uploadBytes(storageRef, file);

  // Get the download URL
  const downloadURL = await getDownloadURL(snapshot.ref);

  return downloadURL;
};
